"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const industries = [{
  name: "Construction & Fleet",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_construction_fleet.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_construction_fleet.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_construction_fleet.png-wvc-sizes",
  alt: "Heavy machinery and fleet management for construction"
}, {
  name: "SaaS & IT Consultants",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_saas_consultants.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_saas_consultants.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_saas_consultants.webp-wvc-sizes",
  alt: "Modern digital workspace for tech consultants"
}, {
  name: "Medical Professionals",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_medical_professionals.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_medical_professionals.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_medical_professionals.webp-wvc-sizes",
  alt: "Clinical environment for medical practitioners"
}, {
  name: "Legal Services",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_legal_services.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_legal_services.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_legal_services.png-wvc-sizes",
  alt: "Professional legal office setting"
}, {
  name: "Engineering Firms",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_engineering_firms.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_engineering_firms.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_engineering_firms.png-wvc-sizes",
  alt: "Architectural planning and engineering design"
}, {
  name: "Retail & E-commerce",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_retail_ecommerce.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_retail_ecommerce.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_retail_ecommerce.webp-wvc-sizes",
  alt: "Modern retail storefront and operations"
}, {
  name: "Trades & Services",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_trades_services.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_trades_services.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_trades_services.png-wvc-sizes",
  alt: "Skilled trade operations and field work"
}, {
  name: "Professional Services",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_professional_services.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_professional_services.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707917/img/industry_professional_services.png-wvc-sizes",
  alt: "Corporate office environment for advisory"
}];
export default function Expertise() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="11468" id="sector-expertise" className="bg-background py-24 md:py-36 text-foreground">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        {}
        <div ref={header.ref} className={`mx-auto max-w-[83.333%] text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex justify-center">
            <div className="h-px w-16" style={{
            backgroundColor: "var(--border)"
          }} />
          </div>
          <p className="mt-6 font-default text-xs font-medium uppercase" style={{
          letterSpacing: "0.14em",
          color: "var(--muted-foreground)"
        }}>
            Sector expertise
          </p>
          <h2 className="mt-5 font-default text-foreground" style={{
          fontSize: "clamp(2rem, 3.6vw, 3.25rem)",
          fontWeight: 400,
          letterSpacing: "-0.018em",
          lineHeight: 1.08
        }}>Industries we <span className="relative inline-block italic" data-ast-id="f:/src/pages/Home/sections/Expertise.tsx|sig:qawkn8" data-ast-start="5300" data-ast-end="5815"><span data-ast-id="f:/src/pages/Home/sections/Expertise.tsx|sig:gmpqw1" data-ast-start="5362" data-ast-end="5380">serve</span><span className="absolute left-0 right-0 -bottom-1 h-px origin-left transition-transform duration-500 ease-out scale-x-100" data-ast-id="f:/src/pages/Home/sections/Expertise.tsx|sig:a6afhz" data-ast-start="5395" data-ast-end="5795" style={{
              backgroundColor: 'var(--chart-1)',
              transitionDelay: '320ms'
            }}></span></span> across Canada</h2>
          <p className="mx-auto mt-6 max-w-2xl font-default text-base text-muted-foreground" style={{
          lineHeight: 1.65
        }}>
            We provide specialized financial architecture for 50+ industries, ensuring your business is built for sustainable growth.
          </p>
        </div>

        {}
        <div ref={grid.ref} className="mt-16 md:mt-20">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-4">
            {industries.map((industry, i) => <div key={industry.name} data-index={i} className={`transition-all ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDuration: "700ms",
            transitionDelay: grid.isVisible ? `${i * 80}ms` : "0ms"
          }}>
                <Link to="/HomePage" aria-label={`Explore ${industry.name} advisory services`} className="group relative block overflow-hidden rounded-lg shadow-md">
                  <AspectRatio ratio={1}>
                    <div className="absolute inset-0 overflow-hidden">
                      <img src={industry.image} data-wvc-srcset={industry.srcset} data-wvc-sizes={industry.sizes} alt={industry.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.04]" />
                    </div>

                    {}
                    <div className="pointer-events-none absolute inset-0 transition-opacity duration-[600ms] ease-out group-hover:opacity-50" style={{
                  backgroundColor: "var(--chart-1)",
                  opacity: 0.08
                }} />

                    {}
                    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/5" style={{
                  background: "linear-gradient(to top, hsla(220, 38%, 8%, 0.65) 0%, hsla(220, 38%, 8%, 0) 100%)"
                }} />

                    {}
                    <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                      <h3 className="font-default" style={{
                    fontSize: "clamp(1.375rem, 1.8vw, 1.75rem)",
                    fontWeight: 420,
                    letterSpacing: "-0.012em",
                    lineHeight: 1.18,
                    color: "var(--background)",
                    textShadow: "0 1px 12px hsla(220, 38%, 8%, 0.45)"
                  }}>
                        {industry.name}
                      </h3>
                    </div>

                    {}
                    <div className="pointer-events-none absolute inset-x-0 bottom-0 overflow-hidden">
                      <div className="h-px w-full origin-left scale-x-0 transition-transform duration-[400ms] ease-out group-hover:scale-x-100" style={{
                    backgroundColor: "var(--chart-1)"
                  }} />
                    </div>
                  </AspectRatio>
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}